export const LAYER_SWITCHER_GROUP_TOGGLE = '@layerSwitcher/LAYER_SWITCHER_GROUP_TOGGLE';
export const LAYER_SWITCHER_SET_FILTER = '@layerSwitcher/LAYER_SWITCHER_SET_FILTER';
export const SET_LAYER_SWITCHER_STATE = '@layerSwitcher/SET_LAYER_SWITCHER_STATE';
export const LAYER_SWITCHER_GROUP_VISIBILITY = '@layerSwitcher/LAYER_SWITCHER_GROUP_VISIBILITY';
export const ADD_LAYER_SWITCHER_LAYERS = '@layerSwitcher/ADD_LAYER_SWITCHER_LAYERS';
//# sourceMappingURL=constants.js.map